<template>
  <v-container class="scrollable" ma-0 pa-0>
    <v-select
      attach
      name="module"
      append-icon="search"
      id="moduleSearch"
      class="module--search__nameflow"
      content-class="createIntervention-content-student"
      :label="$t('attendance.filters.suggestion')"
      :aria-label="$t('attendance.filters.suggestion')"
      autocomplete
      :filter="x => x"
      :items="modules"
      :search-input.sync="searchModules"
      @change="moduleChange"
      v-model="selectedModule"
      clearable
      aria-expanded="false"
      role="search"
    >
    </v-select>
    <v-flex>
      <filter-component :filter-types="moduleFilterTypes"
                        :filter-change="filterChange"
                        :filter-clear="filterClear"
                        :disabled="loadingList"
                        :full-width="true"
      />
    </v-flex>
  </v-container>
</template>

<script>
import DateRangePicker from '../../date/DateRangePicker'
import {mapActions, mapState} from 'vuex'
import {
  SET_ATTENDANCE_MODULE,
  CLEAR_MODULE_FILTERS
} from '../../../store/mutation-types'
import {
  CHANGE_ATTENDANCE_MODULES_FILTERS,
  CLEAR_ATTENDANCE_MODULES_FILTERS,
  GET_STUDENT_MODULE_ATTENDANCE_AVERAGE,
  GET_STUDENT_MODULE_ATTENDANCE_LIST,
  GET_STUDENT_MODULE_ATTENDANCE_SUMMARY_LIST,
  GET_STUDENT_MODULE_LIST
} from '../../../store/action-types'
import FilterComponent from '../../filter/FilterComponent'

export default {
  name: 'attendance-filter',
  data () {
    return {
      searchModules: null
    }
  },
  computed: {
    ...mapState({
      moduleFilterTypes: state => state.attendance.filterFields,
      modules: state => state.attendance.modules,
      loadingList: state => state.attendance.loadingList
    }),
    selectedModule: {
      get () {
        return this.$store.state.attendance.selectedModule
      },
      set (value) {
        this.$store.commit(SET_ATTENDANCE_MODULE, value)
      }
    }
  },
  methods: {
    ...mapActions({
      filterChange: CHANGE_ATTENDANCE_MODULES_FILTERS,
      filterClear: CLEAR_ATTENDANCE_MODULES_FILTERS,
      queryModules: GET_STUDENT_MODULE_LIST
    }),
    moduleChange (data) {
      // if (data.srcElement) {
      //   this.selectedModule = ''
      // }
    },
    loadList () {
      if (this.selectedModule !== undefined && this.selectedModule !== '') {
        this.$store.commit(CLEAR_MODULE_FILTERS)
      }
      this.$store.dispatch(GET_STUDENT_MODULE_ATTENDANCE_LIST)
      this.$store.dispatch(GET_STUDENT_MODULE_ATTENDANCE_AVERAGE)
      this.$store.dispatch(GET_STUDENT_MODULE_ATTENDANCE_SUMMARY_LIST)
    }
  },
  watch: {
    selectedModule (val) {
      this.loadList()
    },
    searchModules (val) {
      val && !val.includes('/') && this.queryModules(val)
    }
  },
  components: {
    FilterComponent,
    DateRangePicker
  }
}
</script>

<style scoped>
  .scrollable {
    max-height: calc(100vh - 160px);
    overflow-y: auto;
  }

  .scrollable {
    max-height: calc(100vh - 160px);
    overflow-y: visible;
    overflow-x: visible;
  }

  .module--search__nameflow >>> .list__tile {
    height: auto;
  }

  .module--search__nameflow >>> .list__tile__title {
    height: auto;
    white-space: -moz-pre-wrap !important;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    white-space: pre-wrap;
    word-wrap: break-word;
    white-space: -webkit-pre-wrap;
    word-break: break-all;
    white-space: normal;
    overflow: visible;
    padding: 0.25em 0;
  }

  @media (max-width: 600px) {
    .scrollable {
      max-height: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/student/attendance/AttendanceFilter.vue